module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/Repositorios/FacturacionWeb/src/app/main/content/Prefijo/MandanteNew.component.html
// module id = ../../../../../src/app/main/content/Prefijo/MandanteNew.component.html
// module chunks = main